import "bootstrap/dist/css/bootstrap.css";
import "bootstrap";
import "../../css/App.scss";
import {Auth, I18n} from "aws-amplify";
import React, {useEffect, useState} from "react";
import awsexports from "../../aws-exports";
import {Authenticator, ConfirmSignUp, ForgotPassword, RequireNewPassword, SignIn, SignUp,} from 'aws-amplify-react';
import AuthenticatedApp from "../AuthenticatedApp";
import {signUpConfig} from "./Config";
import ModalOnSignup from "./ModalOnSignup";
import ModalUnderAge from "./ModalUnderAge";
import UnauthenticatedApp from "../UnauthenticatedApp";
import $ from 'jquery';
import {postValidateEmail} from "../../lib/api";
import UserInfo from "./UserInfo";

const {userPoolId, userPoolClientId} = awsexports;

Auth.configure({
  userPoolId: userPoolId,
  userPoolWebClientId: userPoolClientId,
});

const authLabels = {
  en: {
    'CUSTOM_AUTH is not enabled for the client.': 'Password cannot be empty.',
    'PreSignUp failed with error Please sign up with a work email address.': 'Please sign up with a work email address.',
    'PreSignUp failed with error Please enter your First Name.': 'Please enter your First Name.',
    'PreSignUp failed with error Please enter your Last Name.': 'Please enter your Last Name.',
    'PreSignUp failed with error Please enter your Company Name.': 'Please enter your Company Name',
    'PreSignUp failed with error Villa is for teams and is not recommended for solo use, please enter your work or org email.': 'Villa is for teams and is not recommended for solo use, please enter your work or org email',
    'Family Name': 'Last Name',
    'Given Name': 'First Name',
    'Invalid attributes given, family_name is missing': 'Please enter a Last Name',
    'Invalid attributes given, given_name is missing': 'Please enter a First Name',
    'Invalid password format': 'For the password please use 8 characters minimum, 1 each upper, number, symbol',
    'New Password': "New Password, 8 characters, 1 each upper, number, symbol",
    'Password did not conform with policy: Password must have symbol characters': 'For the password please use 8 characters minimum, 1 each upper, number, symbol',
    'Password did not conform with policy: Password must have uppercase characters': 'For the password please use 8 characters minimum, 1 each upper, number, symbol',
    'Password did not conform with policy: Password must have numeric characters': 'For the password please use 8 characters minimum, 1 each upper, number, symbol',
    'Password did not conform with policy: Password not long enough': 'Password is not long enough, please use 8 characters minimum, 1 each upper, number, symbol',
    'Password does not conform to policy: Password must have symbol characters': 'For the password please use 8 characters minimum, 1 each upper, number, symbol',
    'Password does not conform to policy: Password must have uppercase characters': 'For the password please use 8 characters minimum, 1 each upper, number, symbol',
    'Password does not conform to policy: Password must have numeric characters': 'For the password please use 8 characters minimum, 1 each upper, number, symbol',
    'Password does not conform to policy: Password not long enough': 'Password is not long enough, please use 8 characters minimum, 1 each upper, number, symbol',
    'Enter your code': 'Check email/spam from hello@villa.rocks for confirmation number',
    'Confirmation Code': 'Confirmation number. IMPORTANT: If copy/paste did not work try typing the number in the email received from hello@villa.rocks (check spam), manually',
    "1 validation error detected: Value '703144' at 'confirmationCode' failed to satisfy constraint: Member must satisfy regular expression pattern: [\S]+": "Your confirmation number should be all numbers with no spaces",
    "2 validation errors detected: Value at 'userAlias' failed to satisfy constraint: Member must satisfy regular expression pattern: [\p{L}\p{M}\p{S}\p{N}\p{P}]+; Value at 'userName' failed to satisfy constraint: Member must satisfy regular expression pattern: [\p{L}\p{M}\p{S}\p{N}\p{P}]+": "Please enter a valid email address, with no spaces",
    'Enter your username': 'Enter your email you signed up with',
    'Username': 'Email you signed up with',
    'An account with the given email already exists.': 'An account with the given email already exists. Are you an existing user? Click SIGN IN below. Not yet a user but invited to join an org? Check your email for an invitation from hello@villa.rocks then click SIGN IN and use the provided temporary password. Email info@villa.rocks for help.',
    'User password cannot be reset in the current state.': 'User password cannot be reset in the current state because you were invited to join an org and an account is in progress. Check your email for an invitation from hello@villa.rocks then click SIGN IN and use the provided temporary password in that email. email info@villa.rocks for help.'
  },
};
I18n.setLanguage('en');
I18n.putVocabularies(authLabels);

// For more info check https://docs.amplify.aws/ui/auth/authenticator/q/framework/react
function AuthenticateUser() {
  const [authState, setAuthState] = useState("loading");
  const [cognitoUser, setCognitoUser] = React.useState<any>({});
  const [showHint, setShowHint] = useState(true);
  const [showedHint, setShowedHint] = useState(false);
  const [showUnder13, setShowUnder13] = useState(false);
  const [message, setMessage] = useState('');
  const [userInfo, setUserInfo] = useState({role: "", employees: "", gamerReason: ""});
  let onStateChange = (state: string) => {
    console.error('this should be replaced by SaveChangeState, and never be called', {state})
  };

  function handleAuthStateChange(state: string, data: any) {
    setAuthState(state);
    setCognitoUser(data || {});
    setShowHint(!showedHint && state !== "signedIn");
    setMessage('');
  }

  function turnOffShowHint() {
    setShowHint(false)
    setShowedHint(true)
  }

  function setUnder13() {
    setShowHint(false)
    setShowedHint(true)
    setShowUnder13(true)
  }

  function checkUsername() {
    if (authState !== "signUp") {
      setMessage('');
      return;
    }
    const email = $('input[name="username"]').val();
    postValidateEmail(email).then(response => {
      if (response.ok) {
        response.json().then(json => {
          setMessage(json.message);
        })
      }
    })
  }

  function switchToSignIn() {
    setUserInfo({role: "", employees: "", gamerReason: ""});
    onStateChange('signIn');
  }

  function SaveChangeState(props: any) {
    onStateChange = props.onStateChange;
    return null;
  }


  useEffect(() => {
      $(() => {
        // @ts-ignore
        $('input[name="username"]').on('blur', (e) => {
          checkUsername();
        });
      });
    }
  )

  const app = authState === "loading"
    ? null
    : authState === "signedIn"
      ? <AuthenticatedApp cognitoUser={cognitoUser} userInfo={userInfo}/>
      : <UnauthenticatedApp showHintModal={showHintModal()}/>;

  function showAuthenticate() {
    return !showHint && !showUnder13 && !showUserInfo();
  }

  function showUserInfo() {
    return !showHint && !showUnder13 && authState === "signUp" && (userInfo.role === "" && userInfo.employees === "");
  }

  function showHintModal() {
    return showHint && authState !== "loading";
  }

  useEffect(() => {
    if (window.location.pathname === "/privacy" || window.location.pathname === "/terms") {
      turnOffShowHint();
    }
  }, [window.location.pathname]);

  return (
    <>
      <ModalOnSignup showHint={showHintModal()} setShowedHint={turnOffShowHint} setUnder13={setUnder13}/>
      <ModalUnderAge showUnder13={showUnder13}/>
      {app}
      <UserInfo show={showUserInfo()} signIn={switchToSignIn} setUserInfo={setUserInfo}/>
      <section className={`container authenticate p-4 ${showAuthenticate() ? '' : 'd-none'}`}>
        <div className="row pb-3">
          <div className="col d-none d-sm-flex">&nbsp;</div>
          <div className="col-12 col-md-8 col-lg-6">
            <div className="row col">
              <h5><span className="orange">{message}</span></h5>
            </div>
            <Authenticator hideDefault={true} onStateChange={handleAuthStateChange}
                           signUpConfig={signUpConfig} authState="signUp">
              <SaveChangeState/>
              <SignIn/>
              <SignUp signUpConfig={signUpConfig}/>
              <ConfirmSignUp/>
              <RequireNewPassword/>
              <ForgotPassword/>
            </Authenticator>
            <div className="row col">
              <h5><span className="orange">{message}</span></h5>
            </div>
          </div>
          <div className="col d-none d-sm-flex">&nbsp;</div>
        </div>
      </section>
    </>
  )
}

export default AuthenticateUser;
